/**
 * Vishram — scroll-in motion + night mode offer
 */
(function () {
  'use strict';

  if (window.__vishramMotionInit) {
    return;
  }
  window.__vishramMotionInit = true;

  (function motion() {
    try {
      var prefersReduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-vishram-observe]'));

      if (prefersReduced || typeof window.IntersectionObserver !== 'function') {
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].classList.add('is-visible');
        }
        return;
      }

      var observer = new window.IntersectionObserver(
        function (entries) {
          for (var j = 0; j < entries.length; j++) {
            if (entries[j].isIntersecting) {
              entries[j].target.classList.add('is-visible');
              observer.unobserve(entries[j].target);
            }
          }
        },
        { threshold: 0.2 }
      );

      for (var k = 0; k < nodes.length; k++) {
        nodes[k].classList.add('vishram-fade-up');
        observer.observe(nodes[k]);
      }
    } catch (err) {
      if (window.console && window.console.error) {
        window.console.error('vishram motion error', err);
      }
    }
  })();

  (function nightMode() {
    try {
      var toggle = document.querySelector('[data-vishram-night-toggle]');
      if (!toggle) {
        return;
      }

      var stored = null;
      try {
        stored = window.localStorage.getItem('vishram_night_mode');
      } catch (e) {
        stored = null;
      }

      function apply(on) {
        document.documentElement.classList.toggle('vishram-night', !!on);
      }

      if (stored === '1') {
        apply(true);
      }

      var hour = new Date().getHours();
      if (hour >= 21 && stored === null) {
        toggle.hidden = false;
      }

      toggle.addEventListener('click', function () {
        var isOn = document.documentElement.classList.contains('vishram-night');
        apply(!isOn);
        try {
          window.localStorage.setItem('vishram_night_mode', isOn ? '0' : '1');
        } catch (e) {
        }
      });
    } catch (err) {
      if (window.console && window.console.error) {
        window.console.error('vishram night-mode error', err);
      }
    }
  })();
})();
